import React from "react";
import styles from "./addseller.module.scss";
import Breadcrumbs from "../../Shared/Breadcrumbs";
import { FormGroup, InputGroup, InputGroupText, Label } from "reactstrap";
import Textfield from "../../Shared/Textfield";
import Button from "../../Shared/Button";
import PhoneIcon from "../../../assets/images/phone-icon.png";
import { useFormik } from "formik";
import * as yup from "yup";
import { toast } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setSellers } from "../../Redux/Reducer/appReducer";
import { SignUpUser, updateAccount } from "../../../helpers/service";

const AddSellerSchema = yup.object().shape({
  distributor_name: yup.string().required("Required"),
  distributor_email: yup
    .string()
    .email("Please enter valid email.")
    .required("Required"),
  distributor_phone: yup
    .string()
    .matches(/^\d{10}$/, "Please enter valid phone number")
    .required("Required"),
  distributor_password: yup
    .string()
    .min(8, "Your password is not strong enough. Use at least 8 characters")
    .required("Required"),
});

const AddSeller = () => {
  const dispatch = useDispatch();
  const sellerData = useSelector((state) => state?.appReducer?.sellers);
  const navigation = useNavigate();
  const [loader, setLoader] = React.useState(false);
  const location = useLocation();
  const isAdd = location.state === null;
  const formik = useFormik({
    initialValues: {
      distributor_name: isAdd ? "" : location.state?.name,
      distributor_email: isAdd ? "" : location.state?.email,
      distributor_phone: isAdd ? "" : location.state?.phone,
      distributor_password: isAdd ? "" : location.state?.password,
    },
    validationSchema: AddSellerSchema,
    onSubmit: (values) => {
      onSubmit(values);
    },
  });

  const onSubmit = (values) => {
    setLoader(true);
    const params = {
      name: values?.distributor_name,
      email: values?.distributor_email,
      password: values?.distributor_password,
      confirm_password: values?.distributor_password,
      phone: values?.distributor_phone,
      role: 'seller',
    };
    if (isAdd) {
      SignUpUser(params)
        .then((backendResponse) => {
          if (backendResponse?.success) {
            toast.success(backendResponse.message);
            const newSellerArray = [
              ...sellerData,
              {
                ...params,
                createdAt: new Date().toISOString(),
                updatedAt: new Date().toISOString(),
              },
            ];
            dispatch(setSellers(newSellerArray));
            setTimeout(() => {
              navigation("/seller/seller-list");
            }, 1000);
          } else {
            setTimeout(() => {
              setLoader(false);
            }, 1000);
            toast.error(backendResponse?.response?.data?.message);
          }
        })
        .catch((err) => {
          setTimeout(() => {
            setLoader(false);
          }, 1000);
          toast.error(err);
        });
    } else {
      const editParams = {
        name: values?.distributor_name,
        email: values?.distributor_email,
        password: values?.distributor_password,
        phone: values?.distributor_phone,
        userId: location.state?.id,
      };
      updateAccount(editParams)
        .then((backendResponse) => {
          if (backendResponse?.success) {
            const newSellerArray = sellerData?.map((seller) => {
              if (seller?.id === location.state?.id) {
                return {
                  ...seller,
                  ...editParams,
                };
              } else {
                return seller;
              }
            })
            dispatch(setSellers(newSellerArray));
            navigation("/seller/seller-list");
            toast.success(backendResponse.message);
          } else {
            setTimeout(() => {
              setLoader(false);
            }, 1000);
            toast.error(backendResponse?.response?.data?.message);
          }
        })
        .catch((err) => {
          setTimeout(() => {
            setLoader(false);
          }, 1000);
          toast.error(err);
        });
    }
  };
  return (
    <div>
      <Breadcrumbs
        mainPageTitle={"Seller"}
        path={"/dashboard"}
        subPageTitle={isAdd ? "Add New Seller" : "Edit Seller"}
      />
      <div className={styles["addseller_container"]}>
        <div className={styles["add_seller_form"]}>
          <div>
            <FormGroup>
              <Label for="distributor_name">Name</Label>
              <Textfield
                className="form-control"
                type="text"
                name="distributor_name"
                placeholder="Enter Full Name"
                id="distributor_name"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.distributor_name}
                error={formik.errors.distributor_name}
                touched={formik.touched.distributor_name}
                //   value={name}
              />
            </FormGroup>
          </div>
          <div className={styles["group_inputs"]}>
            <div className={styles["input_container"]}>
              <FormGroup>
                <Label for="distributor_email">Email</Label>
                <InputGroup>
                  <InputGroupText>{"@"}</InputGroupText>
                  <Textfield
                    className="form-control"
                    type="email"
                    name="distributor_email"
                    placeholder="Enter Email"
                    id="distributor_email"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    value={formik.values.distributor_email}
                    error={formik.errors.distributor_email}
                    touched={formik.touched.distributor_email}
                  />
                </InputGroup>
              </FormGroup>
            </div>
            <div className={styles["input_container"]}>
              <FormGroup>
                <Label for="distributor_password">Password</Label>
                <Textfield
                  className="form-control"
                  type="password"
                  name="distributor_password"
                  placeholder="Password enter here"
                  id="distributor_password"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.distributor_password}
                  error={formik.errors.distributor_password}
                  touched={formik.touched.distributor_password}
                />
              </FormGroup>
            </div>
          </div>
          <div className={styles["phone_input"]}>
            <FormGroup>
              <Label for="distributor_phone">Phone</Label>
              <InputGroup>
                <InputGroupText>
                  <img src={PhoneIcon} alt="icon" width={16} height={16} />
                </InputGroupText>
                <Textfield
                  className="form-control"
                  type="email"
                  name="distributor_phone"
                  placeholder="1-(000)-000-000"
                  id="distributor_phone"
                  maxLength={10}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.distributor_phone}
                  error={formik.errors.distributor_phone}
                  touched={formik.touched.distributor_phone}
                />
              </InputGroup>
            </FormGroup>
          </div>

          <div className={styles["add_button_container"]}>
            <Button
              text={isAdd ? "Add Seller" : "Save"}
              className={styles["add_button"]}
              onClick={() => {
                formik.submitForm();
              }}
              disabled={loader}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AddSeller;
